import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-091d2f59"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Recommendations")
const _hoisted_2 = { class: "references-column" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "references-head" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Recommendations"),
  /*#__PURE__*/_createElementVNode("p", { class: "subhead" }, "Colleagues and collaborators, in their own words.")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "state-note"
}
const _hoisted_5 = {
  key: 1,
  class: "state-note"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "reference-quote" }
const _hoisted_8 = { class: "reference-attribution" }
const _hoisted_9 = { class: "reference-name" }
const _hoisted_10 = { class: "reference-role" }
const _hoisted_11 = {
  key: 0,
  class: "reference-relationship"
}
const _hoisted_12 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ThemeToggle = _resolveComponent("ThemeToggle")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, { "default-href": "/" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ThemeToggle)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        class: "references-content"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Loading…"))
              : (_ctx.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.error), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.references, (ref, index) => {
                      return (_openBlock(), _createElementBlock("article", {
                        key: ref.linkedin,
                        class: _normalizeClass(["reference-entry", { 'has-divider': index > 0 }])
                      }, [
                        _createElementVNode("blockquote", _hoisted_7, _toDisplayString(ref.quote), 1),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, _toDisplayString(ref.name), 1),
                          _createElementVNode("div", _hoisted_10, _toDisplayString(ref.role), 1),
                          (ref.relationship)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(ref.relationship), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("a", {
                            class: "reference-linkedin",
                            href: ref.linkedin,
                            target: "_blank",
                            rel: "noopener noreferrer"
                          }, "LinkedIn", 8, _hoisted_12)
                        ])
                      ], 2))
                    }), 128))
                  ]))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}